<template>
<div class="ebook">
    <a class="ebook-cover" :href="book.url" target="_new" rel="nofollow noopener"><img :src="book.image"></a>
    <CompactUser :user="book.user" :linkable="true" :miniprofile="true"></CompactUser>
    <slot name="dropdown"></slot>
    <a class="ebook-title" :href="book.url" target="_new" rel="nofollow noopener"><h2>{{ book.title }}</h2></a>
    {{ book.description }}
    <div class="ebook-pending text-danger" v-if="!book.approved">{{ t && t.assets ? t.assets.modal_avatar.awaiting_approval : '' }}</div>
    <slot></slot>
</div>
</template>

<script>
import CompactUser from 'Profile/component/CompactUser.vue';
import { mapState } from 'vuex';

export default {
    components: {
        CompactUser
    },
    computed: mapState(['t']),
    props: {
        book: {
            type: Object,
            required: true
        }
    }
};

</script>

<style lang="scss" scoped>
@import "~Site/scss/variables";

.ebook {
    font-size: 16px;
    line-height: 1.5;
    min-height: 150px;
    margin-bottom: 20px;
}
.ebook-cover {
    float: left;
    margin-right: 20px;
    img {
        width: 100px;
        height: 150px;
    }
}
.ebook-pending {
    margin-top: 5px;
}
.profile-result {
    float: right;
}
h2 {
    font-size: 1.5em;
    font-weight: 300;
}

@media (max-width: $screen-xs-max) {
    .ebook .dropdown {
        margin-top: 35px;
        float: none !important;
    }
    .ebook-title {
        display: block;
        padding-top: 10px;
        clear: both;
    }
    .profile-result {
        float: none;
    }
}
</style>
